import styled from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Box = styled.div`
  display: block;
  padding: ${props => `${props.theme.padding || 0}px`};
  background-color: ${props => props.theme.backgroundColor || `transparent`};
  margin: ${props => props.theme.margin || 0};
  ${Media.banner`
    margin: ${props => props.theme.marginCont || 0};
  `}

  ${Media.md`
    padding: ${props => `${props.theme.paddingMd || 0}px`};
  `}
  overflow: ${props => props.theme.overflow || 'visible'};
`;

export const Item = styled(RouterLink)`
  position: relative;
  display: block !important;
  width: 100%;
  cursor: pointer;
`;

export const ItemExternal = styled.a`
  position: relative;
  display: block;
  width: 100%;
  cursor: pointer;
`;

export const Imagebox = styled.div`
  display: block;
  width: 100%;
  height: auto;
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
  user-select: none;
`;

export const Content = styled.div`
  position: absolute;
  top: ${props => props.theme.top || 0};
  right: ${props => props.theme.right || 0};
  bottom: ${props => props.theme.bottom || 0};
  left: ${props => props.theme.left || 0};
  transform: ${props => props.theme.transform || 'none'};
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: ${props => `${props.theme.padding || 15}px`};
  background-color: ${props =>
    props.theme.backgroundColor && props.theme.backgroundOpacity
      ? `${props.theme.backgroundColor}${props.theme.backgroundOpacity}`
      : 'transparent'};
  ${Media.md`
    padding: ${props => `${props.theme.paddingMd || 5}px`};
    position: ${props => props.theme.positionMd || 'absolute'};
    background-color: ${props =>
      props.theme.backgroundColorMd || 'transparent'};
    transform: ${props => props.theme.transformMd || 'none'};
  `}
`;

export const Title = styled.h2`
  display: block;
  max-width: 100%;
  width: 100%;
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const NextArrow = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  cursor: pointer;
  border: none;
  outline: none;
  z-index: 1;
  right: ${props => props.theme.offset};
  width: ${props => `${props.theme.size}px`};
  height: ${props => `${props.theme.size}px`};
  filter: ${props => props.theme.filterShadow};
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize}rem`};
  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
  }
  &:hover > svg {
    opacity: 0.75;
  }
`;

export const PrevArrow = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  cursor: pointer;
  border: none;
  outline: none;
  z-index: 1;
  left: ${props => props.theme.offset};
  width: ${props => `${props.theme.size}px`};
  height: ${props => `${props.theme.size}px`};
  filter: ${props => props.theme.filterShadow};
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize}rem`};
  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
  }
  &:hover > svg {
    opacity: 0.75;
  }
`;
